/**
 * A well-formed URL, or undefined (= valid). Empty is allowed — presence is the
 * caller's concern (these are optional URL fields). Shared by the charity
 * create/edit forms.
 */
export const validUrl = (value: unknown): string | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  try {
    new URL(String(value));
    return undefined;
  } catch {
    return 'Must be a valid URL';
  }
};
